import { Box } from '@mui/material';

const ConsecutiveIllust = () => {
  {
    /* <?xml version="1.0" encoding="UTF-8"?> */
  }

  return (
    <Box width={'100%'} display={'contents'}>
      <svg
        id="_レイヤー_2"
        data-name="レイヤー 2"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 300 140"
      >
        <defs>
          <style>
            {`
.cls-1 {
fill: #3c4042;
}

.cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {
stroke-width: 0px;
}

.cls-2 {
fill: #facab6;
}

.cls-9 {
clip-path: url(#clippath);
}

.cls-3, .cls-10, .cls-11 {
fill: none;
}

.cls-4 {
fill: #53585c;
}

.cls-12 {
clip-path: url(#clippath-1);
}

.cls-10 {
stroke-width: 1.64px;
}

.cls-10, .cls-11 {
stroke: #0068b7;
stroke-linecap: round;
stroke-miterlimit: 10;
}

.cls-5 {
fill: #d49175;
}

.cls-11 {
stroke-width: 2.06px;
}

.cls-6, .cls-13 {
fill: #636a6e;
}

.cls-7 {
fill: #0068b7;
}

.cls-8 {
fill: #ff7152;
}`}
          </style>
          <clipPath id="clippath">
            <rect className="cls-3" width="300" height="140" />
          </clipPath>
          <clipPath id="clippath-1">
            <path
              className="cls-6"
              d="M47.02,51.5l-34.18-.18c-.69,0-1.24.55-1.24,1.24v4.17l37.91.54,63.08,36.13v-3.92c0-1.31-.71-2.52-1.85-3.17l-57.93-33.28c-1.77-.99-3.76-1.52-5.78-1.53Z"
            />
          </clipPath>
        </defs>
        <g id="_レイヤー_2-2" data-name="レイヤー 2">
          <g className="cls-9">
            <g>
              <g>
                <g>
                  <path
                    className="cls-2"
                    d="M162.94,83.86s7.7,8.16,1.43,29.19c0,0,22.95,17.19,44.02-8.98,0,0-7.57-13.28-7.04-33.15l-38.41,12.94Z"
                  />
                  <path
                    className="cls-2"
                    d="M124.04-4.47s-18.1,47.5,10.63,83.71c28.73,36.21,74.71-13.86,80.32-22.83,11.22-17.91,21.21-51.81-8.3-73.45-29.52-21.64-73.4-13.2-82.64,12.58Z"
                  />
                  <path
                    className="cls-2"
                    d="M124.11,46.93l-5.71,14.27s6.1,2.07,11.41,1.67l-5.71-15.94Z"
                  />
                  <path
                    className="cls-7"
                    d="M145.26-25.44s-36.2,10.71-26.44,46.44c0,0,.58-4.24,3.56-9.16,0,0,9.74,9.86,23.72,11.58,0,0-2.55-4-3.43-12.85,0,0,5.95,13.17,20.88,14.43l-1.13-9.26s9.36,16.21,23.45,25.47l9.23-.98,2.99,22.97,3.4,10.6s38.19-23.95,24.5-70.08c-13.81-46.51-76.33-40.44-80.72-29.16Z"
                  />
                  <path
                    className="cls-2"
                    d="M167.45,105.78s-12.25,2.81-20.97,8.23c0,0-12.72,22.85,10.48,25.21,23.2,2.36,66.37-31.98,66.37-31.98l-15.37-5.75-40.52,4.29Z"
                  />
                  <g>
                    <path
                      className="cls-5"
                      d="M74.32,108.79s-1.54-29.66-6.14-26.45c-4.6,3.21-4.74,23.99-4.74,23.99l10.88,2.46Z"
                    />
                    <g>
                      <polygon
                        className="cls-1"
                        points="11.6 56.73 75.91 92.9 112.59 93.39 49.51 57.27 11.6 56.73"
                      />
                      <g>
                        <path
                          className="cls-13"
                          d="M47.02,51.5l-34.18-.18c-.69,0-1.24.55-1.24,1.24v4.17l37.91.54,63.08,36.13v-3.92c0-1.31-.71-2.52-1.85-3.17l-57.93-33.28c-1.77-.99-3.76-1.52-5.78-1.53Z"
                        />
                        <g className="cls-12">
                          <polygon
                            className="cls-4"
                            points="50.11 50.93 49.51 57.27 112.59 93.39 112.59 87.35 50.11 50.93"
                          />
                        </g>
                      </g>
                    </g>
                    <path
                      className="cls-2"
                      d="M43.53,129.23s-19.69-38.51-20.41-42.15-10.4-34.06-3.82-33.64c3.35.21,15.14,30.3,15.14,30.3,0,0,2.64-8.02,6.41-13.9,3.99-6.22,12.38-17.1,14.54-14.81,2.88,3.06-5.34,17.56-6.59,21.31s-2.19,8.26-1.84,8.95c.7,1.36,12.71-28.19,17.84-24.32,3.87,2.92-9.03,28.88-6.38,29.6s11.09-23.75,15.27-21.87c5.48,2.46-6.59,26.15-6.59,26.15,0,0,16,20.71,5.12,35.98l-28.69-1.6Z"
                    />
                  </g>
                  <path
                    className="cls-7"
                    d="M160.69,107.72s-10.79,15.75,10.65,14.33c21.44-1.41,44.11-17.76,44.11-17.76,0,0,89.33,23.7,89.96,92.17H81.15s7.65-73.59,79.54-88.75Z"
                  />
                  <path
                    className="cls-2"
                    d="M185.67,44.15s.95-8.79,7.95-9.02c7-.24,9.5,8.55,8.43,12.94-1.07,4.39-7.36,12.82-16.38,11.28v-15.2Z"
                  />
                  <path
                    className="cls-8"
                    d="M130.84,70.44c-.41-.8-.68-2.12.14-2.04,6.06.61,10.67.42,17.35-.72,4.63-.78-.31,10.91-6.77,12.15-4.62.89-9.43-6.86-10.71-9.4Z"
                  />
                  <path
                    className="cls-7"
                    d="M43.53,129.23l28.69,1.6v62.86H23.89s6.02-34.41,19.64-64.46Z"
                  />
                </g>
                <line
                  className="cls-11"
                  x1="123.98"
                  y1="72.81"
                  x2="110.53"
                  y2="72.13"
                />
                <line
                  className="cls-11"
                  x1="126.81"
                  y1="78.49"
                  x2="115.28"
                  y2="83.17"
                />
                <line
                  className="cls-11"
                  x1="130.5"
                  y1="83.75"
                  x2="123.11"
                  y2="93.39"
                />
                <line
                  className="cls-11"
                  x1="135.59"
                  y1="88.99"
                  x2="132.9"
                  y2="100.6"
                />
              </g>
              <ellipse
                className="cls-7"
                cx="143.61"
                cy="44.76"
                rx="2.78"
                ry="3.59"
              />
              <ellipse
                className="cls-7"
                cx="124.44"
                cy="43.37"
                rx="2.2"
                ry="3.33"
                transform="translate(-3.22 10.69) rotate(-4.86)"
              />
              <path className="cls-10" d="M137.89,32.63s6.47-3.19,14.17,2.58" />
              <path className="cls-10" d="M124.03,32.68s-1.91-2.64-5.09-1.98" />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
};

export default ConsecutiveIllust;
